import PropTypes from "prop-types";
import React from "react";
import CoursePlayer from "../../components/CoursePlayer/CoursePlayer";
import { courseSectionTypes } from "../../constants/index";

const CoursePreview = ({
  courseTitle,
  courseSections,
  onPreviewActivityClick
}) => {
  const sections = courseSections.map(courseSection => ({
    ...courseSection,
    activities: courseSection.courseContentables
  }));
  const modules = sections.filter(
    ({ sectionType }) => sectionType === courseSectionTypes.mandatory
  );
  const resources = sections.filter(
    ({ sectionType }) => sectionType === courseSectionTypes.optional
  );

  const handleGoToActivity = (courseContentable, courseSectionId) => {
    onPreviewActivityClick(courseContentable.id, courseSectionId);
  };

  return (
    <CoursePlayer
      courseTitle={courseTitle}
      modules={modules}
      resources={resources}
      totalActivities={modules.length}
      numActivitiesCompleted={0}
      onGoToActivityClick={handleGoToActivity}
    />
  );
};

export default CoursePreview;

CoursePreview.propTypes = {
  courseTitle: PropTypes.string,
  courseSections: PropTypes.array,
  onPreviewActivityClick: PropTypes.func
};
